import React from "react";

import './WhiteBackgroundWrapper.less'

const WhiteBackgroundWrapper = ({children}) => {
    return (
        <div className="white-background-wrapper">
            {children}
        </div>
    )
}

export default WhiteBackgroundWrapper;
